export default __webpack_public_path__ + "static/media/wifi.f22563c3.svg";